import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { makeReference, useApolloClient } from '@apollo/client';
import { Popover, Tooltip, UnavailableInLens } from '@infl-ts/ui-advocate-components';
import { pluralize } from '@infl-ts/util-string-pluralize';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, buttonClasses, IconButton } from '@mui/material';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as L from 'monocle-ts/Lens';
import * as Tr from 'monocle-ts/Traversal';
import { useTranslation } from 'react-i18next';
import NotificationTray from './notification-tray';
import { useMarkAllNotificationsRead } from './notification-tray/mutations';
import { useNotificationsQuery } from './notification-tray/queries';
import { jsx as _jsx } from "react/jsx-runtime";
var setUnreadFlagOnEveryNotification = pipe(L.id(), L.prop('notifications'), L.prop('edges'), L.traverse(A.Traversable), Tr.prop('node'), Tr.prop('unread'), Tr.set(false));

var Notifications = function Notifications(_ref) {
  var profile = _ref.profile,
      unreadNotifications = _ref.unreadNotifications;
  var apolloClient = useApolloClient();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useMarkAllNotificati = useMarkAllNotificationsRead({
    update: function update(cache, data) {
      return pipe(data, E.match(console.error, function () {
        cache.modify({
          id: cache.identify(makeReference('ROOT_QUERY')),
          fields: {
            unreadNotifications: function unreadNotifications() {
              return 0;
            }
          }
        });
      }));
    }
  }),
      _useMarkAllNotificati2 = _slicedToArray(_useMarkAllNotificati, 1),
      mutateMarkAllNotificationsRead = _useMarkAllNotificati2[0];

  var markAllNotificationsReadInCache = function markAllNotificationsReadInCache() {
    return pipe(apolloClient.readQuery({
      query: useNotificationsQuery.document
    }), function (notifications) {
      return notifications ? setUnreadFlagOnEveryNotification(notifications) : {};
    }, function (data) {
      return apolloClient.cache.writeQuery({
        query: useNotificationsQuery.document,
        data: data,
        variables: {
          override: true
        }
      });
    });
  };

  return /*#__PURE__*/_jsx(UnavailableInLens, {
    tooltip: true,
    "data-element": "UnavailableInLens",
    "data-component": "Notifications",
    "data-source-file": "notifications.tsx",
    children: /*#__PURE__*/_jsx(Popover, {
      noPadding: true,
      zIndex: function zIndex(t) {
        return t.zIndex.aboveStickyBlock;
      },
      onOpen: function onOpen() {
        return mutateMarkAllNotificationsRead({
          variables: {
            last: 0
          }
        });
      },
      onClose: markAllNotificationsReadInCache,
      preventFallback: true,
      content: function content() {
        return /*#__PURE__*/_jsx(NotificationTray, {
          profile: profile
        });
      },
      "data-element": "Popover",
      "data-component": "Notifications",
      "data-source-file": "notifications.tsx",
      children: function children(_ref2) {
        var isOpen = _ref2.isOpen;
        return /*#__PURE__*/_jsx(Tooltip, {
          title: t('Notifications'),
          "aria-label": unreadNotifications ? "".concat(unreadNotifications, " unread ").concat(pluralize('notification', 'notifications', unreadNotifications)) : 'Notifications button',
          children: /*#__PURE__*/_jsx(IconButton, {
            sx: _defineProperty({}, "&.".concat(buttonClasses.disabled), {
              color: function color(t) {
                return t.palette.action.disabled;
              }
            }),
            color: isOpen ? 'primary' : 'inherit',
            children: !unreadNotifications ? /*#__PURE__*/_jsx(NotificationsIcon, {}) : /*#__PURE__*/_jsx(Badge, {
              color: "primary",
              badgeContent: unreadNotifications,
              children: /*#__PURE__*/_jsx(NotificationsIcon, {})
            })
          })
        });
      }
    })
  });
};

export default Notifications;